document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.querySelector('[data-table-toggle]');
    const extraRows = document.getElementById('comparison-extra-rows');

    if (toggleBtn && extraRows) {
        toggleBtn.addEventListener('click', function () {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const textSpan = this.querySelector('.toggle-text');
            const iconSpan = this.querySelector('.toggle-icon');

            if (isExpanded) {
                extraRows.classList.add('collapsed');
                this.setAttribute('aria-expanded', 'false');
                textSpan.textContent = 'Show More Details';
                iconSpan.style.transform = 'rotate(0deg)';
            } else {
                extraRows.classList.remove('collapsed');
                this.setAttribute('aria-expanded', 'true');
                textSpan.textContent = 'Show Less Details';
                iconSpan.style.transform = 'rotate(180deg)';
            }
        });
    }
});